import { useAtomValue } from 'jotai';

import type { LeadsTableRow,PaginatedResponse } from '@ekhodealer/ekho-common';

import { useSearchLeads } from '../api/useSearchLeads';
import { leadsParamsAtom } from '../atoms/leadsAtoms';

/**
 * Hook to calculate the count of leads that require action
 * (leads with pending services provider tasks)
 * Uses the same query params as the table (search, filters), but always
 * queries with actionRequired filter enabled to get the count
 */
export function useActionRequiredCount(): number {
	// Get params from atom (includes search, filters, and facets)
	const tableParams = useAtomValue(leadsParamsAtom);

	// Override params to always include actionRequired filter
	// This ensures we get the count regardless of whether user has toggled the filter
	const paramsWithActionRequired = {
		...tableParams,
		filters: {
			...tableParams.filters,
			actionRequired: true,
		},
	};

	// Use the modified query to get action required count from response
	const { data: tableData } = useSearchLeads(paramsWithActionRequired);

	const response = tableData as PaginatedResponse<LeadsTableRow> | undefined;
	return response?.count ?? 0;
}
